import React from "react";

const EmailStats = () => {
    return (
        <>
            <div className="flex space-x-4">
                <div className="p-4 bg-blue-100 rounded-lg">
                    <div className="flex items-center">
                        <svg className="w-6 h-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                        </svg>
                        <div className="ml-3">
                            <div className="text-sm font-medium">Unread Emails</div>
                            <div className="text-2xl font-bold">12</div>
                        </div>
                    </div>
                </div>
                <div className="p-4 bg-red-100 rounded-lg">
                    <div className="flex items-center">
                        <svg className="w-6 h-6 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                        </svg>
                        <div className="ml-3">
                            <div className="text-sm font-medium">High Priority</div>
                            <div className="text-2xl font-bold">5</div>
                        </div>
                    </div>
                </div>
                <div className="p-4 bg-green-100 rounded-lg">
                    <div className="flex items-center">
                        <svg className="w-6 h-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                        </svg>
                        <div className="ml-3">
                            <div className="text-sm font-medium">Total Meetings</div>
                            <div className="text-2xl font-bold">8</div>
                        </div>
                    </div>
                </div>
                <div className="p-4 bg-purple-100 rounded-lg">
                    <div className="flex items-center">
                        <svg className="w-6 h-6 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
                        </svg>
                        <div className="ml-3">
                            <div className="text-sm font-medium">Actions</div>
                            <div className="text-2xl font-bold">15</div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default EmailStats;